module.exports = __webpack_public_path__ + "static/media/PM123.196814e4.png";